import React from "react";
import { useTranslation } from "react-i18next";
import Text from "./Text";
import BaseButton from "./BaseButton";

interface KioskResetWarningProps {
  secondsLeft: number;
  onContinue: () => void;
}

// 下の要素の document リスナー (仮想キーボードの外側タップ判定など) に届かないよう止める
const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

/** 無操作リセットの予告。全面を覆い、どこをタップしても閉じる (下のボタンは押されない) */
const KioskResetWarning: React.FC<KioskResetWarningProps> = ({ secondsLeft, onContinue }) => {
  const { t } = useTranslation();

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black/30"
      onClick={onContinue}
      onPointerDown={stopPropagation}
      onMouseDown={stopPropagation}
      onTouchStart={stopPropagation}
    >
      <div
        role="alertdialog"
        aria-live="assertive"
        aria-labelledby="kiosk-reset-warning-title"
        className="flex flex-col items-center gap-6 rounded-[2rem] bg-white px-16 py-12 text-center shadow-[0_16px_48px_rgba(0,0,0,0.2)]"
      >
        <Text as="h2" id="kiosk-reset-warning-title" variant="heading/l">
          {t("まもなく最初の画面に戻ります")}
        </Text>
        <Text as="p" variant="body/l" weight="bold" className="text-MiraiPrimary">
          {t("あと{{seconds}}秒", { seconds: secondsLeft })}
        </Text>
        <BaseButton
          type="button"
          isSelected
          textVariant="body/l"
          className="min-h-[64px] min-w-[16rem]"
          onClick={(e) => {
            e.stopPropagation();
            onContinue();
          }}
        >
          {t("続けて使う")}
        </BaseButton>
      </div>
    </div>
  );
};

export default KioskResetWarning;
